import React from "react";
import { Formik } from "formik";
import { Divider, TextField, Typography } from "@material-ui/core";

import { appRoutes } from "routes";
import { useRouter, useUsers } from "hooks";
import AccountLayout from "layouts/AccountLayout";
import { initialValues, validationSchema } from "forms/ChangePasswordForm";
import MetaTags from "components/MetaTags";

import { CancelButton, InputPlaceholder, Title, SaveButton } from "../components";

import useStyles from "./useStyles";

const ChangePassword = () => {
  const classes = useStyles();
  const { push } = useRouter();
  const { currentUser, updateUser, signIn } = useUsers();

  const handleSubmit = (values, formikBag) => {
    const params = {
      data: {
        attributes: { password: values.password },
        type: "users",
      },
    };
    return updateUser(params).then(
      () => {
        push(appRoutes.myAccountPath());
        signIn({
          grant_type: "password",
          password: values.password,
          username: currentUser.email,
          relogin: true,
        });
      },
      (error) => {
        formikBag.setFieldError("password", error.response.data.errors[0].detail);
      },
    );
  };

  return (
    <>
      <AccountLayout title="Funny eCards - Send Custom Greeting Cards Online w/ JibJab! - My Account - Change Password">
        <Title title="Change Password" subtitle="Enter your information below to change your password" />

        {currentUser ? (
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {(formik) => (
              <form onSubmit={formik.handleSubmit} className={classes.form}>
                <div className={classes.separator}>
                  <Typography className={classes.separatorTitle}>New</Typography>
                  <Divider />
                </div>

                <TextField
                  margin="normal"
                  placeholder="New Password"
                  id="password"
                  type="password"
                  helperText={formik.touched.password && formik.errors.password}
                  error={formik.touched.password && Boolean(formik.errors.password)}
                  {...formik.getFieldProps("password")}
                />
                <TextField
                  margin="normal"
                  placeholder="Re-Type Password"
                  id="confirmPassword"
                  type="password"
                  helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                  error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                  {...formik.getFieldProps("confirmPassword")}
                />

                <SaveButton>Save New Password</SaveButton>
              </form>
            )}
          </Formik>
        ) : (
          <>
            <InputPlaceholder />
            <InputPlaceholder />
          </>
        )}

        <CancelButton />
      </AccountLayout>
      <MetaTags>
        <meta
          name="og:description"
          content="Personalized eCards from JibJab for every occasion. Browse, customize, send funny greeting cards online for birthdays, holidays, valentines, thank yous & more!"
        />
      </MetaTags>
    </>
  );
};

export default ChangePassword;
